"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireDefault(require("../../../utils/system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CardFooter = (0, _system["default"])('div')({
  label: 'CardFooter'
}, (0, _css["default"])({
  display: 'flex',
  alignItems: 'center',
  p: 5
}));
CardFooter.displayName = 'CardFooter';
var _default = CardFooter;
exports["default"] = _default;

//# sourceMappingURL=CardFooter.js.map